import CustomAudioPlayer from '../modules/customAudioPlayer.js';

(function (Drupal) {
  Drupal.behaviors.audioPlayer = {
    attach: (context) => {
      document.querySelectorAll('audio').forEach((defaultAudioPlayer) => {
        if (defaultAudioPlayer.getAttribute('data-audio-player-init')) {
          return;
        }
        defaultAudioPlayer.setAttribute('data-audio-player-init', 'true');

        const playIcon = '<svg viewBox="0 0 70 85.556" xmlns="http://www.w3.org/2000/svg"><path d="m2.0036 85.068c0.58748 0.32563 1.2367 0.4874 1.8853 0.4874 0.71633 0 1.4316-0.19781 2.0611-0.59111l62.222-38.889c1.1371-0.71063 1.8278-1.9569 1.8278-3.2978 0-1.3409-0.69066-2.5871-1.8278-3.2978l-62.222-38.889c-1.1991-0.74952-2.71-0.78893-3.9464-0.1037-1.2364 0.68548-2.0036 1.9877-2.0036 3.4015v77.778c0 1.4138 0.76715 2.716 2.0036 3.4015z" /></svg>';
        const pauseIcon = '<svg viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg"><path d="m2 0c-1.104 0-2 0.896-2 2v8c0 1.104 0.896 2 2 2s2-0.896 2-2v-8c0-1.104-0.896-2-2-2z"/><path d="m9 0c-1.104 0-2 0.896-2 2v8c0 1.104 0.896 2 2 2s2-0.896 2-2v-8c0-1.104-0.896-2-2-2z"/></svg>';

        const audioPlayer = new CustomAudioPlayer(defaultAudioPlayer, {
          prefix: 'ddmo-audio-player',
          playButtonMarkup: playIcon,
          pauseButtonMarkup: pauseIcon,
        });
      });
    }
  };
}(Drupal));
